export default __webpack_public_path__ + "static/media/messenger-icon.6afff560.png";